var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-modal",
        {
          staticClass: "attestation-modal",
          attrs: { size: "large", closable: false },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c("sui-icon", {
            attrs: { name: "close" },
            on: { click: _vm.closeModal },
          }),
          _c("sui-modal-header", { staticClass: "attestation-modal-header" }, [
            _vm._v(" " + _vm._s(_vm.attestation.Name)),
            _c("br"),
            _vm._v(_vm._s(_vm.toDate(_vm.attestation.Submitted_Date__c)) + " "),
          ]),
          _c(
            "sui-modal-content",
            { attrs: { scrolling: "" } },
            [
              _c("MasterForm", {
                ref: "attestationForm",
                attrs: {
                  id: "attestationForm",
                  firm: _vm.firm,
                  attestation: _vm.attestation,
                  "get-attestaions": _vm.getAttestations,
                },
                on: { closeModal: _vm.closeModal },
              }),
            ],
            1
          ),
          _c(
            "sui-modal-actions",
            [
              _c("sui-button", {
                attrs: {
                  basic: "",
                  type: "button",
                  icon: "arrow down",
                  content: "PDF",
                  size: "small",
                  floated: "left",
                },
                on: { click: _vm.createPDF },
              }),
              _c("sui-button", {
                attrs: {
                  basic: "",
                  size: "small",
                  color: "grey",
                  type: "button",
                  content: "Cancel",
                },
                on: { click: _vm.closeModal },
              }),
              _c("sui-button", {
                attrs: {
                  primary: "",
                  size: "small",
                  type: "button",
                  content: "Save",
                },
                on: { click: _vm.handleSave },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vue-html2pdf",
        {
          ref: "html2Pdf",
          attrs: {
            "show-layout": false,
            "float-layout": true,
            "enable-download": true,
            "preview-modal": false,
            filename: _vm.attestation.Name,
            "paginate-elements-by-height": 1100,
            "pdf-quality": 2,
            "manual-pagination": true,
            "pdf-format": "a4",
            "pdf-orientation": "portrait",
            "pdf-content-width": "100%",
            margin: "2",
          },
        },
        [
          _c(
            "section",
            { attrs: { slot: "pdf-content" }, slot: "pdf-content" },
            [
              _c("MasterForm", {
                attrs: {
                  firm: _vm.firm,
                  attestation: _vm.attestation,
                  "get-attestaions": _vm.getAttestations,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }